"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRfiInterstitial = void 0;
const features_1 = require("../../../features");
const useRfiInterstitialBase_hook_1 = require("./useRfiInterstitialBase.hook");
const initializer_1 = require("../../../initializer");
const react_1 = require("react");
const useRfiInterstitial = ({ rfiData }) => {
    const profileRepository = (0, react_1.useRef)(new features_1.ProfileRepository(initializer_1.API));
    return (0, useRfiInterstitialBase_hook_1.useRfiInterstitialBase)({ rfiData, profileRepository: profileRepository.current });
};
exports.useRfiInterstitial = useRfiInterstitial;
//# sourceMappingURL=useRfiInterstitial.hook.js.map